import React from 'react';
import { LazyImage } from '@teko/ui';
import { Flex, Box } from 'reflexbox';
import { getTrackingData } from '@teko/tracking';
import { CustomLink } from '../CustomLink/CustomLink.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FeaturedBanners = (_a) => {
  var _b = _a, {
    banners,
    regionName
  } = _b, props = __objRest(_b, [
    "banners",
    "regionName"
  ]);
  var _a2, _b2;
  let bannerHeight = 140;
  if (!banners || !banners.length)
    return null;
  if ((_b2 = (_a2 = banners[0]) == null ? void 0 : _a2.imageSize) == null ? void 0 : _b2.height) {
    bannerHeight = Number(banners[0].imageSize.height);
  }
  return /* @__PURE__ */ React.createElement(Flex, __spreadValues(__spreadValues({
    mx: -2
  }, props), {
    "content-visibility": "auto",
    "contain-intrinsic-size": `${bannerHeight}px`
  }), banners.map((banner, index) => {
    return /* @__PURE__ */ React.createElement(Box, __spreadValues({
      px: 2,
      width: 1 / banners.length,
      key: index
    }, regionName && getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: banner.campaignName,
      target: banner.targetPath,
      index
    })), /* @__PURE__ */ React.createElement(CustomLink, {
      targetPath: banner.targetPath
    }, /* @__PURE__ */ React.createElement(LazyImage, {
      borderRadius: 8,
      hover: "zoom",
      height: bannerHeight,
      alt: `banner-${index}`,
      src: banner.image,
      imageWidth: Math.ceil(1232 / banners.length)
    })));
  }));
};

export { FeaturedBanners };
